// src/app/documentation/introduction.ts
import { DocData } from './doc-data';

export const introduction: DocData = {
  titleKey: 'docs.introduction.title',
  descriptionKey: 'docs.introduction.description',
  route: 'introduction',
  iconSvg: `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      class="lucide lucide-book-open h-10 w-10 text-primary">
      <path d="M12 7v14"></path>
      <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"></path>
    </svg>
  `,
  tooltipShortKey: 'docs.introduction.tooltipShort',
  tooltipLinkKey: 'docs.introduction.tooltipLink'
};
